import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { StorageKey, getSessionStorage, setSessionStorage } from '../../../utils/StorageUtils';
import { Option } from '../../../utils/pageConfig/Types';
import { Periodicity } from '../../../components/time-period-selector/PeriodsTypes';

export interface CountryAvailabilityState {
  periodicity: Periodicity;
  periodValue: string;
  subscribedCountries: Option[];
  unavailableCountriesByPeriodAndPg: string[];
}

export type LoadedCountriesState = Pick<
  CountryAvailabilityState,
  'subscribedCountries' | 'unavailableCountriesByPeriodAndPg'
>;

const initialState = (): CountryAvailabilityState => {
  const sessionStorage = getSessionStorage(StorageKey.CountryAvailabilityByPeriodAndPg);

  if (sessionStorage === null) {
    return {
      periodicity: Periodicity.Monthly,
      periodValue: '',
      subscribedCountries: [],
      unavailableCountriesByPeriodAndPg: [],
    };
  }

  return {
    ...JSON.parse(sessionStorage),
  };
};

const availabilityCountrySlice = createSlice({
  name: 'availabilityCountry',
  initialState,
  reducers: {
    countriesAvailabilityBasedPeriodAndPg: {
      reducer: (state, action: PayloadAction<CountryAvailabilityState>) => {
        Object.assign(state, action.payload);
      },
      prepare: (countriesAvailable) => {
        setSessionStorage(
          StorageKey.CountryAvailabilityByPeriodAndPg,
          JSON.stringify(countriesAvailable),
        );
        return {
          payload: countriesAvailable,
        };
      },
    },
  },
});

export const { countriesAvailabilityBasedPeriodAndPg } = availabilityCountrySlice.actions;

export default availabilityCountrySlice.reducer;
